// src/lib/walletLogin.js
import { SiweMessage } from "siwe";
import { signInWithCustomToken, signOut } from "firebase/auth";
import { auth } from "../components/firebase";

const PROJECT = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const REGION = "europe-west3";
const CF_BASE =
  process.env.REACT_APP_CF_BASE || `https://${REGION}-${PROJECT}.cloudfunctions.net`;

const toChainIdNum = (cid) => {
  if (cid == null) return 1;
  if (typeof cid === "string") {
    const last = cid.split(":").pop();
    const n = Number(last);
    return Number.isFinite(n) ? n : 1;
  }
  const n = Number(cid);
  return Number.isFinite(n) ? n : 1;
};

export async function firebaseLoginFromWallet({ address, chainId, signMessageAsync }) {
  // 1) nonce
  const nonceRes = await fetch(`${CF_BASE}/authNonce`, { method: "GET" });
  if (!nonceRes.ok) {
    const t = await nonceRes.text().catch(() => "");
    throw new Error(`authNonce failed: ${t || nonceRes.status}`);
  }
  const nonce = await nonceRes.text();

  const chainIdNum = toChainIdNum(chainId);

  // 2) SIWE message (нормализуем переносы)
  const msg = new SiweMessage({
    domain: window.location.host,
    address,
    statement: "Sign in to PromosPay",
    uri: window.location.origin,
    version: "1",
    chainId: chainIdNum,
    nonce
  });

  const message = msg.prepareMessage().replace(/\r\n/g, "\n");

  // 3) signature
  const signature = await signMessageAsync({ message });

  // ✅ 4) если юзер уже залогинен по email -> LINKING MODE (передаём Bearer)
  // ВАЖНО: true чтобы токен точно свежий (emailVerified/claims могут обновляться)
  const bearer = auth.currentUser ? await auth.currentUser.getIdToken(true) : null;

  // 5) verify -> либо firebaseToken (wallet-login), либо linked:true (linking)
  const verifyRes = await fetch(`${CF_BASE}/authVerify`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(bearer ? { Authorization: `Bearer ${bearer}` } : {})
    },
    body: JSON.stringify({ message, signature })
  });

  if (!verifyRes.ok) {
    const t = await verifyRes.text().catch(() => "");
    throw new Error(`authVerify failed: ${t || verifyRes.status}`);
  }

  const data = await verifyRes.json().catch(() => ({}));

  // ✅ LINKING: не перелогиниваемся, остаёмся в email-сессии
  // БЭК в этом режиме обязан сделать upsertUnifiedUserDoc(... walletToAdd ...)
  if (data?.linked) {
    localStorage.setItem("pp_auth_method", "email");
    localStorage.setItem("pp_wallet", String(address).toLowerCase());
    localStorage.setItem("pp_chain", String(chainIdNum));
    return { mode: "linked", uid: data.uid || auth.currentUser?.uid };
  }

  // ✅ wallet-login/signup: должен прийти custom token
  const firebaseToken = data?.firebaseToken;
  if (!firebaseToken) throw new Error("Missing firebaseToken (expected for wallet-login)");

  await signInWithCustomToken(auth, firebaseToken);

  localStorage.setItem("pp_auth_method", "wallet");
  localStorage.setItem("pp_wallet", String(address).toLowerCase());
  localStorage.setItem("pp_chain", String(chainIdNum));

  return { mode: "wallet", uid: data?.uid || auth.currentUser?.uid };
}

export async function firebaseLogout() {
  localStorage.removeItem("pp_auth_method");
  localStorage.removeItem("pp_wallet");
  localStorage.removeItem("pp_chain");
  try {
    await signOut(auth);
  } catch {}
}
